export default {"src":"/_next/static/media/Icon2.5556009c.svg","height":51,"width":50};